module.exports = "/_next/static/images/a5c50dfe5f100bb2b4f2eb5897a5b973-instant-payments-animation.gif";